import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'
import {BookedCycle, SubscriptionBookingStatusesEnum} from '../types'

export type CycleDraft = {
  venueId: string,
  expireDate: number,
  isPaid: boolean,
  lastPayment: number,
  memberId: string,
  systemType: string,
  cycles: BookedCycle[],
  userId: string,
  isPaidAdditionalFee: boolean,
  subscriptionBookingId: string,
  reference: string,
  status: SubscriptionBookingStatusesEnum.ACTIVE | SubscriptionBookingStatusesEnum.INACTIVE,
}

export type PaySubscriptionBookingForPayParams = {
  draft: CycleDraft,
  entityId: string,
  totalPrice: number
}

export type PaySubscriptionBookingForPayOptions = NonNullable<PaySubscriptionBookingForPayParams>;

export type PaySubscriptionBookingForPayMutationReturnType = undefined

export const paySubscriptionForPayEndpoint = 'payments/entityForPay'

export type PaySubscriptionBookingForPayMuOp = UseMutationOptions<
  PaySubscriptionBookingForPayMutationReturnType,
  AxiosError,
  PaySubscriptionBookingForPayOptions
>


export const paySubscriptionBookingCyclesByOneTimePayment = (params?: PaySubscriptionBookingForPayMuOp): PaySubscriptionBookingForPayMuOp => {
  return ({
    mutationFn: async (options) => {
      const res = await API.post<
        PaySubscriptionBookingForPayOptions,
        PaySubscriptionBookingForPayMutationReturnType
      >(
        paySubscriptionForPayEndpoint,
        {
          collection: 'membershipsBookingsForPay',
          draft: options.draft,
          entityId: options.entityId,
        }
      )
      return res.data
    },
    ...params
  })
}
